import * as React from 'react';
import styled from '@emotion/styled';
import { IPAD_MEDIA, PHONE_MEDIA } from '../media';

export interface CardGridWidgetProps {
  children?: React.ReactNode;
  className?: string;
  columns?: number;
  gap?: number;
}

export const CardGridWidget: React.FC<CardGridWidgetProps> = ({ children, className, columns = 3, gap = 20 }) => (
  <S.Grid className={className} $columns={columns} $gap={gap}>
    {children}
  </S.Grid>
);

namespace S {
  export const Grid = styled.div<{ $columns: number; $gap: number }>`
    display: grid;
    grid-template-columns: repeat(${(p) => p.$columns}, minmax(0, 1fr));
    gap: ${(p) => p.$gap}px;
    min-width: 0;
    ${IPAD_MEDIA} {
      grid-template-columns: repeat(${(p) => Math.min(p.$columns, 2)}, minmax(0, 1fr));
    }
    ${PHONE_MEDIA} {
      grid-template-columns: minmax(0, 1fr);
    }
  `;
}
